/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Tue, Jul 20th 2021, 11:14:33 am
 *
 * *****************************************************
 */

import { Stack } from '@shopify/polaris';

import Spinner from 'features/common/views/components/Spinner';

import { PageContainer } from './styles';

/**
 * Loading content when signing in to workspace
 */
const WorkspaceSignInLoading = () => (
  <PageContainer>
    <Stack alignment="center">
      <Spinner />
      <span>Loading ...</span>
    </Stack>
  </PageContainer>
);

export default WorkspaceSignInLoading;
